// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentInsuranceVerificationModel {
    static getAttributeTypeMap() {
        return EnrollmentInsuranceVerificationModel.attributeTypeMap;
    }
}
EnrollmentInsuranceVerificationModel.discriminator = undefined;
EnrollmentInsuranceVerificationModel.attributeTypeMap = [
    {
        "name": "insuranceType",
        "baseName": "insuranceType",
        "type": "TCSInsuranceType"
    },
    {
        "name": "payerName",
        "baseName": "payerName",
        "type": "string"
    },
    {
        "name": "payerPhone",
        "baseName": "payerPhone",
        "type": "string"
    },
    {
        "name": "bin",
        "baseName": "bin",
        "type": "string"
    },
    {
        "name": "pcn",
        "baseName": "pcn",
        "type": "string"
    },
    {
        "name": "payerMedicalId",
        "baseName": "payerMedicalId",
        "type": "string"
    }
];
//# sourceMappingURL=enrollmentInsuranceVerificationModel.js.map